// import * as CookieConsent from "vanilla-cookieconsent";
// window.CookieConsent = CookieConsent;

import initBurger from "./components/burger.js";
import initVideoplayers from "./components/videos.js";
import initIntroAnimation from "./components/intro.js";
import initHeaderScroll from "./components/header.js";

window.addEventListener('DOMContentLoaded', () => {
  initBurger();
  initVideoplayers();
  initHeaderScroll();

  if (document.querySelector('.slider')) {
    import('./components/slider.js').then(({ default: initSlider }) => initSlider());
  }

  if (document.querySelector('lottie-player')) {
    import('./components/lottie.js').then(({ default: initLottieAnimations }) => initLottieAnimations());
  }
});

window.addEventListener('load', () => {
  initIntroAnimation();

  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    import('./components/mouse.js').then(({ default: initMouse }) => initMouse());
  }
});
